import { ValueOf } from '@shared/types/common';

export const CREATIVE_TYPE = {
  DEFAULT: 'default',
  LSHAPE: 'l-shape',
  LANDING: 'landing',
  SWITCH_IN: 'switch-in',
  HIGH_IMPACT: 'high-impact',
  VIDEO: 'video',
} as const;

export type CreativeType = ValueOf<typeof CREATIVE_TYPE>;

export const CREATIVE_CATEGORY = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
} as const;

export type CreativeCategory = ValueOf<typeof CREATIVE_CATEGORY>;
